import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { riskCategory } from "./options";
import { getDataToChart } from "../../../helpers/helper";
import { useAction } from "../../../hooks/actions";
import Responsible from "../../components/MapPopUp/Responsible";
import DonutChart from "../../components/DonutChart";
import TaskStateList from "../../components/TaskStateList/TaskStateList";
import RiskCategoryButton from "../../components/ToggleButtonsGroup/RiskCategoryButton";

export const HoverPopUp = ({ data, width, height, radius, thickness }) => {
  return (
    <Box className="donut">
      <DonutChart
        data={data || []}
        width={width}
        height={height}
        radius={radius}
        thickness={thickness}
        fontSize={"32px"}
      />
      <TaskStateList height="12px" width="12px" taskStateWidth={"calc(100% - 136px)"} data={data || []} />
    </Box>
  );
};
export const HoverPopUpWithoutTaskList = ({ data, width, height, thickness, style }) => {
  return <DonutChart data={data || []} width={width} height={height} style={style} thickness={thickness} />;
};

const ObjectDetails = ({ data, onClose, isObjectOnMap = true }) => {
  const { t } = useTranslation();
  const { setSortParamsFacilityName } = useAction();

  const { riskCategoryOption, jobChart, name } = useMemo(() => {
    if (!data) {
      return {
        riskCategoryOption: null,
        protectionObjectSystemsData: null,
      };
    }
    return {
      riskCategoryOption: riskCategory.find(({ value }) => value === data?.riskCategory),
      jobChart: data?.messageChart,
      name: data?.name,
    };
  }, [data]);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: "16px" }}>
        <Typography className="pop_up_header">
          {data?.integrationNumber} {data?.name}
        </Typography>
        <IconButton className="close_icon" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box className="main-content_wrapper" sx={{ justifyContent: isObjectOnMap ? "space-between" : "flex-end" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <Box className="box">
            <img
              className="img"
              src={data?.protectionObjectPhoto || data?.protectionObjectPhotoLink || "/unnamed.png"}
              alt={data?.protectionObjectPhoto || data?.protectionObjectPhotoLink || "unnamed"}
            />
          </Box>

          <Box sx={{ margin: 0 }} className="data_text">
            {t("label:phone")}: {data?.phoneNumber || "Номер телефона отсутствует"}
          </Box>

          <Box sx={{ margin: 0 }} className="data_text">
            {t("label:mainFunctionalPurpose")}: {data?.mainFunctionalPurpose}
          </Box>

          <Box sx={{ m: 0 }} className="data_text">
            {t("label:riskCategory")}:{" "}
            {data?.riskCategory ? <RiskCategoryButton {...riskCategoryOption} /> : "Не определена"}
          </Box>

          <HoverPopUp
            data={{
              fireMessagesAmount: jobChart?.fireMessagesAmount || "0",
              falseFireMessagesAmount: jobChart?.falseFireMessagesAmount || "0",
              action: `?facilityName=${data?.id}`,
            }}
            width={104}
            height={104}
            radius={52}
            thickness={10}
          />
        </Box>
      </Box>

      {data?.customerOrganizations && (
        <Box sx={{ mt: "28px" }}>
          <Typography className="data_small_headers">{t("label:customer")}</Typography>
          {data?.customerOrganizations.map(({ jobChart, ...organization }, i) => (
            <Accordion
              key={i}
              sx={{
                boxShadow: "none",
                padding: 0,
              }}
            >
              <AccordionSummary style={{ padding: "0" }} expandIcon={<ExpandMoreIcon />}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography style={{ padding: "0", alignSelf: "center" }}>
                    <span>
                      {organization?.name}: {organization?.systems}
                    </span>
                  </Typography>
                  <HoverPopUpWithoutTaskList
                    data={getDataToChart({
                      jobChart,
                      action: setSortParamsFacilityName.bind(null, name),
                    })}
                    width={36}
                    style={{
                      marginRight: "10px",
                    }}
                    height={36}
                    radius={18}
                    thickness={3}
                  />
                </Box>
              </AccordionSummary>

              <AccordionDetails style={{ padding: "0" }}>
                <Responsible data={organization?.contactPersons} />
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}
      {data?.responsibleOrganizationContactPersons && (
        <Box>
          <Typography className="data_small_headers">{t("label:performers")}</Typography>
          {data?.responsibleOrganizationContactPersons.map(({ jobChart, ...organization }, i) => (
            <Accordion
              key={i}
              sx={{
                boxShadow: "none",
                padding: 0,
              }}
            >
              <AccordionSummary style={{ padding: "0" }} expandIcon={<ExpandMoreIcon />}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography style={{ padding: "0", alignSelf: "center" }}>
                    <span>
                      {organization?.name}: {organization?.systems}
                    </span>
                  </Typography>
                  <HoverPopUpWithoutTaskList
                    data={getDataToChart({
                      jobChart,
                      action: setSortParamsFacilityName.bind(null, name),
                    })}
                    width={36}
                    style={{
                      marginRight: "10px",
                    }}
                    height={36}
                    radius={18}
                    thickness={3}
                  />
                </Box>
              </AccordionSummary>

              <AccordionDetails style={{ padding: "0" }}>
                <Responsible data={organization?.contactPersons} />
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}
    </>
  );
};

export default ObjectDetails;
